import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import DrawerNav from "../Navigation/DrawerNav";
import { BASE_URL } from "../../Api/constants";
import { useNavigate } from "react-router-dom";

export default function AddQuizV2() {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [url, setUrl] = useState("");
  const [type, setType] = useState("practice");
  const [price, setPrice] = useState(""); // <-- NEW
  const navigate = useNavigate();

  const handleSaveChanges = async () => {
    try {
      const response = await fetch(`${BASE_URL}/api/v1/quiz`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name,
          description,
          imageURL: url,
          type,
          price, // <-- NEW
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setName("");
        setDescription("");
        setUrl("");
        setType("practice"); // (kept a sane default after reset)
        setPrice(""); // <-- NEW
        navigate("/exam-management");
      } else {
        console.error(data.message || "Failed to add quiz");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <Box sx={{ display: "flex" }}>
      <DrawerNav />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Box p={2}>
          <Typography
            variant="h4"
            sx={{ my: 2, fontWeight: "bolder", color: "#4b4848" }}
          >
            Add New Quiz
          </Typography>

          <TextField
            label="Quiz Name"
            value={name}
            onChange={(event) => setName(event.target.value)}
            fullWidth
            variant="outlined"
            margin="normal"
          />

          <TextField
            label="Quiz Description"
            value={description}
            onChange={(event) => setDescription(event.target.value)}
            fullWidth
            variant="outlined"
            margin="normal"
            multiline
            minRows={2}
          />

          <TextField
            label="Quiz Image URL"
            value={url}
            onChange={(event) => setUrl(event.target.value)}
            fullWidth
            variant="outlined"
            margin="normal"
          />

          {/* NEW: Price (string) */}
          <TextField
            label="Price"
            value={price}
            onChange={(event) => setPrice(event.target.value)}
            fullWidth
            variant="outlined"
            margin="normal"
            placeholder="e.g., Free, ₹99, $4.99"
          />

          <FormControl fullWidth variant="outlined" margin="normal">
            <InputLabel id="quiz-type-label">Quiz Type</InputLabel>
            <Select
              labelId="quiz-type-label"
              value={type}
              onChange={(event) => setType(event.target.value)}
              label="Quiz Type"
            >
              <MenuItem value="practice">Practice</MenuItem>
              <MenuItem value="course">Course</MenuItem>
            </Select>
          </FormControl>

          <Box mt={2}>
            <Button
              variant="contained"
              color="success"
              onClick={handleSaveChanges}
            >
              Add Quiz
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
